import React from 'react';
import { Grid, Typography, Box, Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import './RecentProjects.css';
import { useNavigate } from 'react-router-dom';

// Importing images
import BenbrackWindFarmImage from '../../images/Projects/Benbrack_Wind_Farm.png';
import ClashindarrochIIImage from '../../images/Projects/Clashindarroch_II_Wind_Farm.png';
import SandyKnoweImage from '../../images/Projects/SandyKnowe_Wind_Farm.png';
import ScapaDeepWaterQuayImage from '../../images/Projects/Scapa_Deep_Water_Quay.png';

const projects = [
  {
  id: 1,
  title: 'recentProjects.scapaTitle',
  image: ScapaDeepWaterQuayImage,
  link: '/scapaDeepWaterQuay',
  cost: '£200m+'
},
{
  id: 2,
  title: 'recentProjects.clashindarrochIITitle',
  image: ClashindarrochIIImage,
  link: '/clashindarrochIIWindFarm',
  cost: 'Confidential'
},
{
  id: 3,
  title: 'recentProjects.benbrackTitle',
  image: BenbrackWindFarmImage,
  link: '/benbrackWindFarm',
  cost: 'Confidential'
},
{
  id: 4,
  title: 'recentProjects.sandyknoweTitle',
  image: SandyKnoweImage,
  link: '/sandyknoweWindFarm',
  cost: 'Confidential'
}
];

function RecentProjects() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleExploreMore = () => {
    // 1) update URL (even if already on /projects)
    navigate('/projects#projects');

    // 2) force the scroll immediately
    const el = document.getElementById('projects');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className={`recent-projects-section ${inView ? 'fade-in' : ''}`}>
      <Box className="recent-projects-header">
        <HomeIcon className="recent-projects-icon" />
        <Typography variant="subtitle2" className="recent-projects-title">
          {t('recentProjects.header')}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" className="recent-projects-main-header">
        <Typography variant="h3" className="recent-projects-main-title">
          {t('recentProjects.mainTitle')}
        </Typography>
        <Button variant="contained" color="primary" className="recent-projects-explore-more-button" onClick={handleExploreMore}>
          {t('recentProjects.exploreMore')}
        </Button>
      </Box>
      <Grid container spacing={4} className="recent-projects-grid">
        {projects.map(project => (
          <Grid item xs={12} sm={6} md={6} key={project.id} className="recent-projects-grid-item">
            <Box
              className="recent-projects-project"
              style={{ backgroundImage: `url(${project.image})` }}
            >
              <Box className="recent-projects-project-overlay">
                <Typography variant="h5" className="recent-projects-project-title">
                  {t(project.title)}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </section>
  );
};

export default RecentProjects;
